import React, { useLayoutEffect, useRef } from 'react';
import { ImageUp, X } from 'lucide-react';
import { API } from '../../../lib/api';
import { urlImagen } from '../../../lib/formularios';
import { Switch } from '../../ui/switch';

/** Textarea que crece con el texto: los títulos de pregunta pueden ocupar varias líneas, como en Google. */
export function TextoCreciente({ value, onChange, className = '', minFilas = 1, inputRefExterno, ...resto }) {
  const ref = useRef(null);
  const asignar = (el) => {
    ref.current = el;
    if (inputRefExterno) inputRefExterno.current = el;
  };
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${el.scrollHeight}px`;
  }, [value]);
  return (
    <textarea
      ref={asignar}
      rows={minFilas}
      value={value ?? ''}
      onChange={onChange}
      className={`fe-texto-creciente ${className}`}
      {...resto}
    />
  );
}

/** Círculo, cuadrado o número delante de cada opción, según el tipo de pregunta. */
export function GlifoOpcion({ tipo, indice }) {
  if (tipo === 'desplegable') return <span className="fe-glifo fe-glifo-numero">{indice + 1}.</span>;
  return <span className={`fe-glifo ${tipo === 'casillas' ? 'fe-glifo-casilla' : 'fe-glifo-radio'}`} aria-hidden="true" />;
}

/** Imagen subida al formulario (pregunta, opción o bloque de imagen) con su botón de quitar. */
export function ImagenAdjunta({ imagen, alt = '', onQuitar, onCambiar, className = '' }) {
  if (!imagen?.id) return null;
  return (
    <div className={`fe-imagen-adjunta ${className}`}>
      <img src={urlImagen(imagen.id, API)} alt={alt} className="fm-imagen" loading="lazy" />
      {(onQuitar || onCambiar) && (
        <div className="fe-imagen-acciones">
          {onCambiar && (
            <button type="button" className="fe-icono-btn fe-icono-flotante" onClick={onCambiar} aria-label="Cambiar imagen" title="Cambiar imagen">
              <ImageUp />
            </button>
          )}
          {onQuitar && (
            <button type="button" className="fe-icono-btn fe-icono-flotante" onClick={onQuitar} aria-label="Quitar imagen" title="Quitar imagen">
              <X />
            </button>
          )}
        </div>
      )}
    </div>
  );
}

/** Fila "texto + interruptor", la de Configuración y los menús de preferencias. */
export function FilaInterruptor({ titulo, descripcion, checked, onChange, disabled, id }) {
  return (
    <label className={`fe-fila-ajuste ${disabled ? 'is-deshabilitada' : ''}`} htmlFor={id}>
      <span className="fe-fila-ajuste-texto">
        <span className="fe-fila-ajuste-titulo">{titulo}</span>
        {descripcion && <span className="fe-fila-ajuste-desc">{descripcion}</span>}
      </span>
      <Switch id={id} checked={!!checked} onCheckedChange={onChange} disabled={disabled} />
    </label>
  );
}

/** <select> nativo con el aspecto del editor: en el teléfono abre el selector del sistema, que es lo cómodo. */
export function Selector({ value, onChange, opciones, className = '', etiqueta, disabled }) {
  return (
    <select
      className={`fe-select ${className}`}
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value)}
      aria-label={etiqueta}
      disabled={disabled}
    >
      {opciones.map((o) => (
        <option key={String(o.valor)} value={o.valor} disabled={o.deshabilitada}>{o.texto}</option>
      ))}
    </select>
  );
}
